<template>
    <div class="add-episode-transcript-tab">
        <form-editor
            v-model="transcript"
        />
    </div>
</template>
<script>
import { mapMutations, mapState } from 'vuex';
import FormEditor from '@/components/Form/FormEditor';

export default {
    components: {
        FormEditor,
    },

    computed: {
        ...mapState({
            addEpisodeModal: state => ({ ...state.UIState.addEpisodeModal }),
        }),

        transcript: {
            /**
             * Gets transcript value.
             *
             * @returns {string} Episode transcript.
             */
            get() {
                return this.addEpisodeModal.episode.transcript || '';
            },

            /**
             * Sets transcript value.
             *
             * @param {string} value Episode transcript.
             */
            set(value) {
                this.addEpisodeModal.episode.transcript = value;

                this.changeUIState({ addEpisodeModal: this.addEpisodeModal });
            },
        },
    },

    methods: {
        ...mapMutations(['changeUIState']),
    },
};
</script>
